export const selectProducts = (state) => state.product.products;
export const selectProductsLoading = (state) => state.product.loading;
export const selectProductsError = (state) => state.product.error;
export const selectProductSuccess = (state) => state.product.success;

//By Admin
export const selectProductsByAdmin = (state) => state.product.products;
export const selectProductsByAdminLoading = (state) => state.product.loading;
export const selectProductsByAdminError = (state) => state.product.error;
export const selectProductByAdminSuccess = (state) => state.product.success;
